module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mute-button",
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('headphone-icon', {
    staticClass: "headphone"
  }), _c('ul', {
    staticClass: "volume",
    class: {
      'active': !_vm.isMuted
    }
  }, [_c('li', {
    staticClass: "bar"
  }), _c('li', {
    staticClass: "bar"
  }), _c('li', {
    staticClass: "bar"
  })])], 1), _c('div', {
    staticClass: "cta",
    class: {
      'active': _vm.isMuted || _vm.force
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('volumeCta')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3c81b72"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/race/ui/MuteButton.vue
// module id = 437
// module chunks = 1